<template>
  <r-panel :disabled="disabled" :title="title" :button_add="true" @click_add="click_add">
    <r-plinko-bucket-config-table ref="table" :items.sync="_items" :toolbar="false" :title="title"/>
  </r-panel>
</template>
<script>

import VueTypes from "vue-types";
import {PlinkoBucketConfig} from "@/modules/redactor/models/smart-offer/bundle-plinko/PlinkoBucketConfig";

import RPanel from "@/modules/redactor/views/utils/r-panel.vue";
import RPlinkoBucketConfigTable from "@/modules/redactor/views/smart-offer/bundle-plinko/r-plinko-bucket-config-table.vue";

export default {
  name: "r-plinko-bucket-config-panel",
  components: {RPlinkoBucketConfigTable,  RPanel},
  props: {
    disabled: VueTypes.bool.def(false),
    title: VueTypes.string.def("Buckets"),
    items: VueTypes.arrayOf(PlinkoBucketConfig)
  },
  computed: {
    _items() {
      if (this.items) {
        return this.items;
      } else {
        let values = [];
        this.$emit("update:items", values);
        return values;
      }
    }
  },
  methods: {
    click_add() {
      this.$refs["table"].row_create();
    }
  }
}

</script>